import { Container, Grid } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { ButtonAddHLPure, GridPure, SearchBarHLPure } from '../../pures'
import { useHistory } from 'react-router-dom'
import NewConversationDialog from './components/new-conversation-dialog'
import { useTranslation } from 'react-i18next'


const ChatbotConfigurationConversationsView = (props) => {
    const {
        initialMessage,
        conversations,
        createConversation,
        deleteConversation
    } = props

    const { t } = useTranslation('chatbot', { keyPrefix: 'conversationsConfig' })
    const { t: tCommon } = useTranslation('common')
    const [conversationsAux, setConversationsAux] = useState(conversations || [])
    const [searchTerm, setSearchTerm] = useState('')

    const history = useHistory()
    const [showNewConversationDialog, setShowNewConversationDialog] = useState(false)
    const toggleNewConversationDialog = () => setShowNewConversationDialog(prev => !prev)

    const onAddConversation = async (data) => {
        setShowNewConversationDialog(false)
        await createConversation(data)
    }

    const onViewConversation = (conversation) => { history.push({ pathname: `/assistant-configuration/conversation/${conversation.id}`,})}

    const [formKey, setFormKey] = useState(1)
    const resetForm = () => setFormKey(formKey + 1)
    useEffect(() => {
        resetForm()
    }, [initialMessage])

    const filterSearch = (event) => {
        const value = event.target.value
        setSearchTerm(value)
        if (value) setConversationsAux(conversations.filter(conversation => conversation.name.toLowerCase().includes(value.toLowerCase())))
        else setConversationsAux(conversations || [])
    }

    useEffect(() => {
        if (searchTerm) setConversationsAux( conversations.filter(conversation => conversation.name.toLowerCase().includes(searchTerm.toLowerCase())))
        else setConversationsAux(conversations || [])
    }, [conversations])

    return (
        <>
            {
                showNewConversationDialog &&
                <NewConversationDialog
                    onAddConversation={onAddConversation}
                    onClose={toggleNewConversationDialog}
                    t={t} tCommon={tCommon}
                />
            }
            <Container maxWidth={'md'} style={{ marginTop: '20px' }}>
                <Grid container spacing={3}>
                    <p style={{ paddingLeft: '12px' }}>{t("conversations.conversationalDescription")}</p>
                    <Grid item xs={12} className="add-and-search-container">
                        <ButtonAddHLPure
                            iconAdd={true}
                            nameBtn={t("conversations.flow")}
                            onClick={toggleNewConversationDialog}
                        />
                        <SearchBarHLPure
                            placeholder={tCommon("search")}
                            onSearchChange={filterSearch}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <GridPure
                            dataGrid={conversationsAux}
                            skip={0}
                            take={6}
                            rowsItems={[
                                {
                                    field: 'name',
                                    title: tCommon("name"),
                                },
                                {
                                    field: 'Acciones',
                                    width: 120,
                                    actions: true
                                }
                            ]}
                            actions={[
                                {
                                    type: 'view-details',
                                    value: tCommon("details"),
                                    onClick: (conversation) => onViewConversation(conversation)
                                },
                                {
                                    type: 'icon',
                                    value: 'k-icon k-i-delete k-i-trash',
                                    onClick: (conversation) => deleteConversation(conversation.id)
                                },
                            ]}
                        />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

export default ChatbotConfigurationConversationsView